const middleware = {}

middleware['init'] = require('../middleware/init.js')
middleware['init'] = middleware['init'].default || middleware['init']

middleware['redirects'] = require('../middleware/redirects.js')
middleware['redirects'] = middleware['redirects'].default || middleware['redirects']

export default middleware
